import React, { useEffect, useState } from "react";


import { useDispatch, useSelector } from "react-redux";

import "./DataMapping.css";
import { Box } from "@mui/material";
import CreateDataMapping from "../CreateDataMapping/CreateDataMapping";
import MappingStatus from "../MappingStatus/MappingStatus";

function DataMapping() {
  const [loading, setLoading] = React.useState(false);
  const [showFlowDiv, setShowFlowDiv] = React.useState(false);
  const EmpId = useSelector((state: any) => state.authApiSlice.Id);
  const ActiveClient = useSelector(
    (state: any) => state.clientDetails.activeClient
  );
  const [selectedEnv, setSelectedEnv] = useState<any>("");
  const [activeTab, setActiveTab] = useState<number>(1);

  const handleTabChange = (activeTab: number) => {
    setActiveTab(activeTab);
  };

  return (
    <>
      <div className="tab-page-layout-1">
        <div className="tab-page-layout-1-header config-header-section multibab">
          <button
            className={"tablinks" + (activeTab == 1 ? " activetab" : "")}
            onClick={() => handleTabChange(1)}
          >
            Create Mapping
          </button>
          <button
            className={"tablinks" + (activeTab == 2 ? " activetab" : "")}
            onClick={() => handleTabChange(2)}
          >
            Import Status
          </button>
        </div>
        <div className="tab-page-layout-1-body">
          {activeTab == 1 && <CreateDataMapping />}
          {activeTab == 2 && <MappingStatus />}
        </div>
      </div>
    </>
  );
}

export default DataMapping;
